<template>
    <ed-modal
      :show="show"
      :title="title"
      primary-button="OK"
      secondary-button="CANCEL"
      @close="onClose"
      @validate="onSave"
      :validation="true"
      :closeOnEsc="true"
       name='rush_payment'
    >
    <div class="content" slot="body">
        <div class="small">
            You have selected an Invoice Due Date that is earlier than the standard Payment Terms for your company with the supplier.
             Please enter a Rush Payment Reason to request this Rush Payment.
        </div>
        <br/>
        
        <div class="panel panel-danger panel-side no-icon">
          <div class="panel-heading">
          </div>
          <div class="panel-body">
            <div>
              This rush payment request has a {{this.model.RushPaymentTermsDays}}-day payment term,
              which is {{this.model.DaysEarlier}} days earlier than the {{this.model.HasDiscountedPaymentTerm ? 'discounted' : 'standard'}} {{this.model.StandardRushPaymentDays}}-day payment term.
            </div>
          </div>
        </div>

        <br/>
        <div>
            <ed-textarea
              field-label="Rush Payment Reason"
              v-model="reason"
              @input="reasonChanged"
              :max-length="250"
              :rows="4"
              required
              ref="reasonText"
              name="rush_payment_textarea"
            >
            </ed-textarea>
        </div>
        <br/>
    </div>
    </ed-modal>
</template>

<script>

import { EventBus } from '@/event-bus'

export default {
  props: {
    model: Object,
    eventHub: Object
  },
  data: function() {
    return {
      show: true,
      reason: this.model.Reason,
      displayReasonError: false
    }
  },
  computed: {
    title() {
      return this.model.IsSameDayDeposit
          ? 'Request Rush Payment - ' + utils.constants.invoice.SameDayLabel
          : 'Request Rush Payment'
    }
  },
  methods: {
    onClose() {
      EventBus.$emit('closeRushPayment', this.model.InitialDueDate)
      this.show = false
      this.displayReasonError = false
    },

    onSave() {
      if (!this.isValid()) return
      this.model.Reason = (this.reason || '').trim()
      EventBus.$emit('saveRushPayment', this.model.Reason)
      this.show = false
    },

    reasonChanged() {
      if (this.displayReasonError) {
        this.isValid()
      }
    },

    isValid() {
      this.updateReasonErrorAttribute(false)
      if ((this.reason || '').trim() === '') {
        this.updateReasonErrorAttribute(true)
        return false
      }
      return true
    },

    updateReasonErrorAttribute(val) {
      if (this.$refs.reasonText && this.$refs.reasonText.$el.children[1]) {
        if (val) {
          this.displayReasonError = true
          this.$refs.reasonText.$el.children[1].setAttribute('error', val)
        } else {
          this.displayReasonError = false
          this.$refs.reasonText.$el.children[1].removeAttribute('error')
        }
      }
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.float-l {
  float:left;
}

.no-pad {
    padding: 0;
    margin: 0;
}

.col-2-8 {
  width: 22%
}

.col-6-10 {
  width: 60%
}

.text-danger {
  @include theme {
  color: v(urgent-01);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/RequestRushPayment.vue